const MODULE_NAME = 'PATIENT_DATA_EXPORT';
const FETCH_SOURCES_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_SOURCES_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const FETCH_MEASUREMENT_TYPES_STARTED = MODULE_NAME + 'MEASUREMENT_TYPE_FETCH_STARTED';
const FETCH_MEASUREMENT_TYPES_COMPLETED = MODULE_NAME + 'MEASUREMENT_TYPE_FETCH_COMPLETED';
const EXPORT_STARTED = MODULE_NAME + 'EXPORT_STARTED';
const EXPORT_COMPLETED = MODULE_NAME + 'EXPORT_COMPLETED';
const EXPORT_FAILED = MODULE_NAME + 'EXPORT_FAILED';

export {
  FETCH_SOURCES_STARTED,
  FETCH_SOURCES_COMPLETED,
  FETCH_MEASUREMENT_TYPES_STARTED,
  FETCH_MEASUREMENT_TYPES_COMPLETED,
  EXPORT_STARTED,
  EXPORT_COMPLETED,
  EXPORT_FAILED
};
